export enum ChecklistV2ReportPages {
    Dashboard,
    WidgetDetailsOpenChecklists,
    ChecklistReportDetails,
    WidgetDetailsDeviations,
    ChecklistDeviationDetails,
    WidgetDetailsPastChecklists,
    ChecklistHistoryDetails,
    ChecklistHistoryUnitMetrics,
    AttachmentListOpenChecklists,
    AttachmentListHistory,
}
